import { RootState } from '../store';

export const selectIsOnboardingOpen = (state: RootState): boolean =>
  state.onboarding.isOpen;
